/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseAdminDto } from '../../models/response-admin-dto';
import { UpdateAdminDto } from '../../models/update-admin-dto';

export interface AdminsControllerUpdate$Params {

/**
 * The tenant of the admin
 */
  tenant: string;

/**
 * The admin id
 */
  id: string;
      body: UpdateAdminDto
}

export function adminsControllerUpdate(http: HttpClient, rootUrl: string, params: AdminsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminsControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseAdminDto>;
    })
  );
}

adminsControllerUpdate.PATH = '/thalea-admins/admins/{tenant}/{id}';
